import React from 'react';
const points = [{
  num: '01',
  title: 'Dimanche après-midi = Anxiété.',
  desc: 'Vous sacrifiez votre repos pour chercher quels drills proposer le lundi afin de ne pas toujours répéter la même chose.'
}, {
  num: '02',
  title: "Le travail ne s'arrête jamais.",
  desc: "Après vos heures de cours ou de boulot, vous rentrez avec la charge mentale de préparer l'entraînement du lendemain."
}, {
  num: '03',
  title: 'Des joueurs qui "stagnent".',
  desc: "Vous sentez qu'il vous manque des outils pour qu'ils voient des résultats réels dans leur technique et leur fluidité de jeu."
}, {
  num: '04',
  title: 'Vous cherchez la reconnaissance.',
  desc: "Vous voulez être l'entraîneur qui présente un programme rigoureux, moderne et d'excellence dans son club."
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-137">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <span className="inline-block text-primary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-141">
            👀 Reconnaissez-vous ces scènes ?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-142">
            Le Pack Complet Handball Prêt est pour vous{' '}
            <span className="text-primary" data-id="element-143">si vous vivez ceci :</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-144">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-all group shadow-lg hover:-translate-y-1" data-id="element-145">
              <div className="text-primary/30 group-hover:text-primary font-black text-3xl sm:text-4xl flex-shrink-0 transition-colors tracking-tighter" data-id="element-146">
                {point.num}
              </div>
              <div className="flex-1" data-id="element-147">
                <h3 className="text-text-main text-lg sm:text-xl font-bold leading-snug mb-2" data-id="element-148">
                  {point.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-149">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-150">
          <p className="text-text-main text-lg sm:text-xl font-bold mb-6" data-id="element-151">
            ✋ Vous vous êtes reconnu ? Alors ce Kit est exactement pour vous.
          </p>
          <a href="#pricing" className="inline-block bg-cta-green text-white font-black text-base sm:text-xl px-8 sm:px-10 py-4 rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-152">
            🚀 JE VEUX RÉCUPÉRER MON TEMPS
          </a>
        </div>
      </div>
    </section>;
}